import { createRoot } from 'react-dom/client';
import { init } from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import App from './App';

const root = createRoot(document.getElementById('root'));

console.log(import.meta.env.VITE_RELEASE);

import.meta.env.MODE === 'production' &&
  init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    release: import.meta.env.VITE_RELEASE,
    environment: import.meta.env.MODE,
    integrations: [new BrowserTracing()],
    autoSessionTracking: false,
  });

root.render(<App />);
